/* eslint func-style: "off" */
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  //actions
  FETCH_DOMAINS,
  UPDATE_DOMAINS,
  CONFIRM_CANCEL,
  // action creators
  fetchDomains,
  fetchDomainsSucceeded,
  fetchDomainsFailed,
  updateDomainsSucceeded,
  updateDomainsFailed
} from './TierOverride.ducks';

import apiClient from 'helpers/apiClient';

const getAccountId = (state) => state.TierOverride.accountId;
const getTiers = (state) => state.TierOverride.tiers;
const getRedirectTarget = (state) => state.TierOverride.redirectTarget;

export const fetchTierDomains = function* () {
  try {
    const accountId = yield select(getAccountId);
    const path = `/api/accounts/${accountId}/media-score-reach-tiers`;
    const tiers = yield call(apiClient, path, { method: 'GET' });
    yield put(fetchDomainsSucceeded({tiers}));
  } catch (e) {
    yield put(fetchDomainsFailed());
  }
};

export const updateDomains = function* () {
  try {
    const accountId = yield select(getAccountId);
    const tiers = yield select(getTiers);
    const body = JSON.stringify(tiers);
    const path = `/api/accounts/${accountId}/media-score-reach-tiers`;
    yield call(apiClient, path, { method: 'PUT', body });
    yield put(updateDomainsSucceeded());
  } catch (e) {
    yield put(updateDomainsFailed());
    yield put(fetchDomains());
  }
};

export const confirmCancel = function* () {
  // 'redirectTarget' should only be defined if user has clicked a tab with unsaved work
  const redirectTarget = yield select(getRedirectTarget);
  if (redirectTarget){
    // setTimeout needed because of the modal
    setTimeout(() => {
      window.$(redirectTarget).click();
    }, 0);
  }
};

export const fetchDomainsSaga = function* () {
  yield takeLatest( FETCH_DOMAINS, fetchTierDomains);
};

export const updateDomainsSaga = function* () {
  yield takeLatest( UPDATE_DOMAINS, updateDomains);
};

export const confirmCancelSaga = function* () {
  yield takeLatest( CONFIRM_CANCEL, confirmCancel);
};

const sagas = function* () {
  yield all([
    fork(fetchDomainsSaga),
    fork(updateDomainsSaga),
    fork(confirmCancelSaga)
  ]);
};

export default sagas;
export {
  // selectors
  getAccountId,
  getTiers,
  getRedirectTarget
};

